module.exports = __webpack_public_path__ + "img/690-4b5d12.png";